import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=1489ec3e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1489ec3e"]])

export default __exports__